import { render, staticRenderFns } from "./TabelaFreteFilterBar.vue?vue&type=template&id=22252af2"
import script from "./TabelaFreteFilterBar.vue?vue&type=script&lang=js"
export * from "./TabelaFreteFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports